import { connect } from 'react-redux';
import ModalView from './ModalView';
import { modalOpened, modalClosed } from './redux';

const mapDispatchToProps = {
  modalOpened,
  modalClosed,
};

export default connect(undefined, mapDispatchToProps)(ModalView);
